import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import services from './modules/services';
import resources from './modules/resources';
import bookings from './modules/bookings';
import packages from './modules/packages';
import settings from './modules/settings';
import stores from './modules/stores';
import roster from './modules/roster';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    services,
    resources,
    bookings,
    packages,
    settings,
    stores,
    roster
  }
});
